import { render, staticRenderFns } from "./HealthEducationMonitoring.vue?vue&type=template&id=07da2964&scoped=true"
import script from "./HealthEducationMonitoring.vue?vue&type=script&lang=js"
export * from "./HealthEducationMonitoring.vue?vue&type=script&lang=js"
import style0 from "./HealthEducationMonitoring.vue?vue&type=style&index=0&id=07da2964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da2964",
  null
  
)

export default component.exports